import { ContextMenuItem } from "@/components/ui/context-menu";

interface Props extends React.ComponentProps<"div"> {
  inputElement: HTMLInputElement | HTMLTextAreaElement | null;
  onOpenAccessModal: () => void;
}

const AccessInput: React.FC<Props> = ({ inputElement, onOpenAccessModal }) => {
  return (
    <ContextMenuItem
      className="flex items-center justify-between"
      onSelect={(event) => {
        event.preventDefault();
        if (!inputElement) return;

        onOpenAccessModal();
      }}
    >
      دسترسی
    </ContextMenuItem>
  );
};

export default AccessInput;
